import React, { useState } from "react";
import CustomButton from "../CustomButton";
import CustomSelect from "../CustomSelect";
import ModalLayout from "../layouts/ModalLayout";
import { Link } from "react-router-dom";
import { MONTHS } from "../../util/Constants";
import { useBranchCode } from "../../util/hooks/useBranch";

interface Props {
  onClose?: () => void;
}

function StaffAttendanceReportYearly({ onClose }: Props) {
  const [formData, setFormData] = useState({
    year: "2026",
    month: "JANUARY",
  });

  const handleInputChange = (e: React.ChangeEvent<any>) => {
    const { name, value } = e.target;
    // If it's the year select, extract just the starting year (e.g., "2026")
    const finalValue = name === "year" ? value.split("-")[0] : value;
    setFormData((prev) => ({ ...prev, [name]: finalValue }));
  };

  const branchCode = useBranchCode();

  const viewUrl = `/staff-attendance-report/${branchCode}/?year=${formData.year}&month=${formData.month}`;

  return (
    <ModalLayout onClose={onClose}>
      <div className="flex flex-col gap-8 max-w-xl">
        <h3 className="text-xl font-semibold text-neutral-400">
          Attendance Report - Month Wise
        </h3>

        <CustomSelect
          name="year"
          label="Academic Year"
          value={formData.year}
          options={["2026", "2027", "2028"]}
          placeholder="Select academic Year"
          onChange={handleInputChange}
        />

        <CustomSelect
          name="month"
          label="Month"
          value={formData.month}
          options={MONTHS}
          placeholder="Select Month"
          onChange={handleInputChange}
        />

        <div className="flex justify-end gap-5">
          <CustomButton
            color="bg-neutral-200"
            text="Cancel"
            onClick={onClose}
          />
          <Link target="_blank" to={viewUrl}>
            <CustomButton
              color="bg-primary-500"
              text="View"
              disabled={!formData.year || !formData.month}
            />
          </Link>
        </div>
      </div>
    </ModalLayout>
  );
}

export default StaffAttendanceReportYearly;
